import { Icon } from "@iconify/react"

export function Spinner({ spinning = true, children }) {
  if (!spinning) return children || null

  if (children) {
    return (
      <div className="relative">
        <div className="opacity-50 pointer-events-none">{children}</div>
        <div className="absolute inset-0 flex items-center justify-center">
          <Icon icon="eos-icons:three-dots-loading" className="text-3xl" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center">
      <Icon icon="eos-icons:three-dots-loading" className="text-3xl" />
    </div>
  )
}
